var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstateCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 113,
    viewBox: "0 0 116 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 112.5C90.9279 112.5 116 87.4279 116 56.5C116 25.5721 90.9279 0.5 60 0.5C29.0721 0.5 4 25.5721 4 56.5C4 87.4279 29.0721 112.5 60 112.5Z",
    fill: "#BEE5F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.493 75.9982C105.493 75.9982 99.9602 76.258 98.8224 70.4723C97.6902 64.6828 98.1163 65.3035 96.395 63.9213C94.6752 62.539 97.9126 61.5153 98.6381 58.4848C99.3637 55.459 96.7147 51.7315 99.6664 49.051C102.62 46.3705 109.658 49.2805 111.084 52.5918C112.514 55.9016 113.591 56.4546 112.361 59.3794C111.134 62.3041 110.478 64.6408 110.399 67.8105C110.322 70.9795 111.53 75.3223 105.493 75.9982H105.493Z",
    fill: "#678C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.809 90L104.898 89.9976L104.988 53L105.898 53.0024L105.809 90Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.236 63L100.898 58.674L101.559 58L105.898 62.3268L105.236 63Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.631 65.3203L100.898 66L105.28 70.0981L106.014 69.4184L101.631 65.3203Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.527 63L105.898 62.3031L111.268 57L111.898 57.6994L106.527 63Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.563 71L105.898 70.3145L111.231 64L111.898 64.6847L106.563 71Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4168 71.9976C12.4168 71.9976 5.2567 72.3438 3.78426 64.6959C2.31893 57.0448 2.87238 57.8647 0.643588 56.0379C-1.58283 54.2119 2.6071 52.8596 3.54662 48.8544C4.48614 44.8562 1.05729 39.9291 4.87773 36.3884C8.70054 32.8469 17.806 36.6928 19.6534 41.0666C21.5048 45.4427 22.8952 46.1738 21.3059 50.0383C19.7182 53.9036 18.8702 56.99 18.7676 61.1806C18.6673 65.3674 20.2306 71.1059 12.4168 71.9984V71.9976Z",
    fill: "#678C3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9108 90L12 89.9984L12.0897 41L13 41.0023L12.9108 90Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0746 55L6 48.9441L6.92621 48L13 54.0568L12.0746 55Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71984 57.3059L6 58L11.7335 63.5792L12.4533 62.885L6.71984 57.3059Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8403 54L12 53.0716L19.1613 46L20 46.9317L12.8403 54Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8892 64L12 63.1193L19.1123 55L20 55.8815L12.8892 64Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0294 76.9983C23.0294 76.9983 17.8217 77.2492 16.7519 71.6697C15.6852 66.0871 16.0888 66.6851 14.4688 65.3516C12.8481 64.0212 15.8953 63.0331 16.5783 60.1113C17.2621 57.1918 14.7689 53.5985 17.5463 51.0136C20.3269 48.4286 26.9499 51.2348 28.292 54.4271C29.6397 57.6194 30.6515 58.1525 29.4948 60.9727C28.339 63.7921 27.722 66.0465 27.6472 69.1027C27.5756 72.1583 28.7123 76.3456 23.0286 76.9975L23.0294 76.9983Z",
    fill: "#678C3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9113 90L23 89.9969L23.0894 55L24 55.0015L23.9113 90Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3383 65L19 60.6761L19.6617 60L24 64.3273L23.3383 65Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3352 72L19 67.6625L19.6657 67L24 71.3392L23.3352 72Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6298 65L23 64.3046L28.3718 59L29 59.6997L23.6298 65Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6673 71L23 70.4123L28.3327 65L29 65.5869L23.6673 71Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2793 38.6698L78.313 32.5496L87.1081 32.5983L87.0379 45.7928L78.2793 38.6698Z",
    fill: "#E7D4C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7207 88.0071L29.9166 51.7463L59.7846 30.7837L88.8739 51.5743L88.6724 89.054L29.7207 88.0071Z",
    fill: "#E7D4C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.831 91.7026L29.7207 91.3717L29.765 82.8738L88.8739 83.2054L88.831 91.7026Z",
    fill: "#264053"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7155 65.5769L68.5861 53.7388L83.5766 64.6847L83.4298 92.5856L53.5586 92.422L53.7155 65.5769Z",
    fill: "#E7D4C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3237 67.1263L50.9097 60.4784L67.6272 46.6758L85.7337 58.1274L86.225 66.0076L68.1294 54.7408L51.3702 67.865L51.3237 67.1263Z",
    fill: "#264053"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0255 55.1313L28.8379 46.8792L60.3339 23.7207L91.5226 47.3956L91.4803 55.5045L60.7624 31.8882L29.0255 55.1313Z",
    fill: "#264053"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2633 89.9369L59.7388 89.8414L59.8746 64.3333L77.3964 64.4301L77.2633 89.9369Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.634 75.8108L61.5044 75.7785L61.5557 66.0991L67.6846 66.1329L67.634 75.8108Z",
    fill: "#E29C25"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5796 75.8108L69.4507 75.7778L69.502 66.0991L75.6309 66.1336L75.5796 75.8108Z",
    fill: "#E29C25"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5569 77.5768L61.5044 87.2883L67.6845 87.3218L67.737 77.6102L61.5569 77.5768Z",
    fill: "#E29C25"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6963 87.2884L68.5674 87.2553L68.6187 77.5767L74.7476 77.609L74.6963 87.2884Z",
    fill: "#E29C25"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4254 77.5765L34.1353 77.5087L34.2061 64.3333L46.4956 64.3996L46.4254 77.5765Z",
    fill: "#E29C25"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4095 70.5135L35.9009 70.4927L35.9237 66.0991L39.4324 66.1192L39.4095 70.5135Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7069 70.5135L41.1982 70.4941L41.2225 66.0991L44.7298 66.1185L44.7069 70.5135Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.924 71.3964L35.9009 75.8108L39.4324 75.8293L39.4555 71.4149L35.924 71.3964Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6054 33.4324L76.5137 33.3592L76.5495 27.2522L90.6398 27.3254L90.6054 33.4324Z",
    fill: "#264053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7069 76.6937L41.1982 76.6736L41.2218 72.2793L44.7298 72.2987L44.7069 76.6937Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 89.937,
    width: 111,
    height: 7.06306,
    fill: "#C57029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateCard);
export default __webpack_public_path__ + "static/media/RealEstateCard.6e3fcc4997257b63a0f768c4642e73ad.svg";
export { ForwardRef as ReactComponent };